import {Component, EventEmitter, Input, OnInit, Output, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {TileGroupComponent} from '../tile-group/tile-group.component';
import {ProductsService} from '../../shared/services/products.service';

@Component({
    selector: 'mbnm-filters',
    templateUrl: './filters.component.html',
    styleUrls: ['./filters.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FiltersComponent implements OnInit {

  constructor(private productService: ProductsService) { }

  ngOnInit() {
  }

  @ViewChild('tiles')
  tiles: TileGroupComponent;

  @Input()
  options: any;

  @Input()
  productData: Array<any>;

  @Output()
  filterChanged: EventEmitter<Array<any>> = new EventEmitter<Array<any>>();

  deselect(): void {
    this.tiles.selectedTile = null;
  }

  onSelectionChanged(newValue, currentOption) {
    currentOption.previousSelection = currentOption.selection;
    currentOption.selection = newValue;
    this.updateFilteredProduct(currentOption);
  }

  updateFilteredProduct(currentOption) {
    // calculate the tags
    let tags = this.productService.getTags(this.options);

    // apply the current filters
    let filteredData = this.productService.filterByTags(this.productData, tags);


    let onSelectionChangedContinue = () => {
      const hasMatches = (option, choice): boolean => {
        const oldTagValue = tags[option.tagName];
        tags[option.tagName] = choice.value;
        const retValue = this.productService.filterByTags(this.productData, tags).length > 0;

        if (typeof oldTagValue === 'undefined') {
          delete tags[option.tagName];
        } else {
          tags[option.tagName] = oldTagValue;
        }

        return retValue;
      };

      // go over options again and re-select the previous value if it has matches
      // or the first available if it is
      let changeOccured: boolean = false;
      this.options.forEach(option => {
        option.choices.forEach(choice => {
          if (option.selection == null) {
            const previousSelection = option.choices.filter(choice => choice.value == option.previousSelection)[0];
            if (previousSelection && hasMatches(option, previousSelection)) {
              option.selection = previousSelection.value;
            } else {
              const firstAvailableSelection = option.choices.filter(choice => hasMatches(option, choice))[0];
              option.selection = firstAvailableSelection.value;
            }
            tags[option.tagName] = option.selection;
            changeOccured = true;
          }
        });
      });

      // if any change occurred, update the available mats to reflect the new tags
      if (changeOccured) {
        filteredData = this.productService.filterByTags(this.productData, tags);
      }

      // output the changed data
      this.filterChanged.emit(filteredData);
    };

    const keepChanges = () => {
      this.options.forEach(option => {
        if (option !== currentOption) {
          option.previousSelection = option.selection;
          option.selection = null;
          delete tags[option.tagName];
        }
      });

      filteredData = this.productService.filterByTags(this.productData, tags);
      onSelectionChangedContinue();
    };

    // if we will end up with zero results, change tags and get some good results
    if (filteredData.length === 0) {
      keepChanges();
    } else {
      onSelectionChangedContinue();
    }
  }
}
